import { isSameDay } from 'date-fns';

import { Text } from '../../cdl/Text/Text';
import { formatDate } from '../../common/helpers/formatDate.helper';
import { formatDateTime } from '../../common/helpers/formatDateTime.helper';
import { translate } from '../../common/helpers/translate.helper';
import { Characters } from '../../common/helpers/unicode.helper';
import { IconInfoCircle } from '../../common/icons/cdl/InfoCircle';
import { InfoPopover } from '../../common/InfoPopover/InfoPopover';
import { Box } from '../../common/ui/Box';
import { useDemandDefinitionReferencePeriodPresets } from '../hooks/useDemandDefinitionReferencePeriodPresets';

interface DemandReferencePeriodValueProps {
    from?: Date;
    to?: Date;
}

export const DemandReferencePeriodValue = ({ from, to }: DemandReferencePeriodValueProps) => {
    const presets = useDemandDefinitionReferencePeriodPresets();

    if (!from || !to) {
        return <Text variant="subtitle1">{Characters.EN_DASH}</Text>;
    }

    const matchingPreset = presets.find((preset) => isSameDay(preset.from, from) && isSameDay(preset.to, to));
    const periodLabel =
        matchingPreset?.label ??
        `${formatDate({ date: from.getTime() })} ${Characters.HYPHEN_MINUS} ${formatDate({ date: to.getTime() })}`;

    return (
        <Box display="flex" alignItems="center" gap={6} minWidth={0}>
            <Text variant="subtitle1" truncated>
                {periodLabel}
            </Text>
            {matchingPreset ? (
                <Box display="flex" alignItems="center" flexShrink={0} height={24}>
                    <InfoPopover Icon={IconInfoCircle} side="right" width="257px">
                        <Box display="flex" flexDirection="column" gap={8}>
                            <Text variant="extraSmall">{translate('demandDefinition.exactReferencePeriodDates')}</Text>
                            <Text variant="extraSmall">
                                {formatDateTime({ date: from.getTime(), format: 'EEEE, d MMMM yyyy' })}
                                {Characters.NO_BREAK_SPACE}
                                {Characters.EN_DASH}
                                {Characters.NO_BREAK_SPACE}
                                {formatDateTime({ date: to.getTime(), format: 'EEEE, d MMMM yyyy' })}
                            </Text>
                        </Box>
                    </InfoPopover>
                </Box>
            ) : null}
        </Box>
    );
};
